<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-layout row justify-center>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" v-if="!enableReservation" @click="setEnableReservation">修改</v-btn>
          </v-card-title>
          <v-subheader v-if="ownerType==='group'">单位配置</v-subheader>
          <v-subheader v-if="ownerType==='object'">个人配置</v-subheader>
          <v-layout v-if="ownerType==='group'" class="mb-3">
            <v-flex xs4 class="pl-4">
              <v-autocomplete
                :disabled="(status!=='new')||(!enableReservation)"
                :items="searchSelects"
                v-model="ownerId"
                v-on:keyup="getSelection"
                label="分组名称"
                clearable
                hide-details
                hide-selected
                item-text="name"
                item-value="id"
                :rule="[$rules.requiredS('必填')]"
              >
                <template slot="no-data">
                  <v-alert :value="true" color="error">
                    暂无该用户组信息
                  </v-alert>
                </template>
                <template slot="item" slot-scope="props">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-flex row align-center justify-between>
                        <span>{{props.item.name}}</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <span class="grey--text caption text-xs-right">{{props.item.code}}</span>
                  </v-list-tile-action>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout v-if="ownerType==='object'" class="mb-3">
            <v-flex xs4 class="pl-4">
              <v-autocomplete
                :disabled="(status!=='new')||(!enableReservation)"
                :items="searchSelects"
                v-model="ownerId"
                v-on:keyup="getSelection"
                label="个人名称"
                clearable
                hide-details
                hide-selected
                item-text="name"
                item-value="id"
                :rule="[$rules.requiredS('必填')]"
              >
                <template slot="no-data">
                  <v-alert :value="true" color="error">
                    暂无该用户信息
                  </v-alert>
                </template>
                <template slot="item" slot-scope="props">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-flex row align-center justify-between>
                        <span>{{props.item.name}}</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                  </v-list-tile-action>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 class="pl-4">
              <v-switch
                class="py-0"
                label="全局开关"
                persistent-hint
                :disabled="!enableReservation||readonly"
                v-model="isEnabled"
              ></v-switch>
            </v-flex>
          </v-layout>
          <v-container v-if="isEnabled">
            <v-form ref="form1">
              <v-layout v-if="enableReservation||readonly">
                <v-flex>
                  <l-select-controller
                    label-c="禁止预约通行关口"
                    label-p="禁止预约停车场区"
                    placeholder="没有配置"
                    :disabled="!enableReservation||readonly"
                    v-model="specificParkingLot"
                  ></l-select-controller>
                </v-flex>
              </v-layout>
            </v-form>
            <v-divider></v-divider>
            <v-form ref="form2">
              <template v-for="(c,key , i) in configs">
                <v-layout class="py-2" v-if="c.type === 'input'" row :key="key" align-center>
                  <v-flex class="px-2" :key="'label' + i" xs8>
                        <span
                          class="subheading grey--text"
                        >{{c.label}}</span>
                  </v-flex>
                  <v-flex :key="'input' + i" xs2 offset-xs2>
                    <v-text-field
                      :disabled="!enableReservation||readonly"
                      hide-details
                      :rules="$rules.positiveInteger"
                      class="py-0 my-0"
                      v-model="c.value"
                      :type="c.inputType"
                      :suffix="c.suffix"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout :key="key" v-else-if="c.type==='switch'">
                  <v-flex xs12>
                    <v-switch
                      class="py-0"
                      :label="c.label"
                      persistent-hint
                      :disabled="!enableReservation||readonly"
                      v-model="c.value"
                    ></v-switch>
                  </v-flex>
                </v-layout>
                <v-layout class="py-2" align-center :key="key" v-else-if="c.type==='select'">
                  <v-flex class="px-2" xs7>
                        <span
                          class="subheading grey--text"
                        >{{c.label}}</span>
                  </v-flex>
                  <v-flex xs5>
                    <v-select
                      class="py-0 mt-0"
                      hide-details
                      :items="c.items"
                      :disabled="!enableReservation||readonly"
                      v-model="c.value"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-subheader class="mt-4" :key="key" v-else-if="c.type==='header'">{{c.label}}</v-subheader>
              </template>
            </v-form>
            <v-divider></v-divider>
            <v-layout class="pb-3">
              <v-subheader>预约资源</v-subheader>
            </v-layout>
            <v-layout column>
              <div
                class="subheading grey--text pl-1"
              >园区关口组合选项
              </div>
              <v-list dense>
                <v-list-tile v-if="preControllers.length===0">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <div class="text-xs-center grey--text">没有配置</div>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-group
                  :key="i"
                  v-for="(p,i) in preControllers">
                  <template slot="activator">
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{p.name}}
                        </v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action v-if="!readonly && enableReservation">
                        <v-menu left>
                          <v-btn slot="activator" icon small>
                            <v-icon small>$vuetify.icons.more</v-icon>
                          </v-btn>
                          <v-list dense>
                            <!-- @click="controllerDialog={activate: true,  status: 'edit',item: p.item,index:i}"-->
                            <v-list-tile
                              @click="editControllerConfig(p,i)"
                            >
                              <v-list-tile-title class="pr-1">
                                <v-flex layout align-center>
                                  <span>修改配置</span>
                                </v-flex>
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                              @click="deleteControllerConfig(i)"
                            >
                              <v-list-tile-title class="pr-1">
                                <v-flex layout align-center>
                                  <span>删除配置</span>
                                </v-flex>
                              </v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                  <v-list-tile
                    v-for="(subItem,index) in p.controllers"
                    :key="index">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{subItem.name}}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
              </v-list>
              <v-flex v-if="!readonly && enableReservation">
                <v-btn
                  @click="controllerDialog={activate: true,  status: 'new'}"
                  class="px-0"
                  small
                  flat
                  color="primary"
                >添加配置
                </v-btn>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout column v-if="orderType==='order_letter'||orderType==='order_group'">
              <div
                class="subheading grey--text pl-1"
              >单位单日可约次数上限
              </div>
              <v-list dense>
                <v-list-tile :key="i" v-for="(p,i) in groupMaxReservationPerDay">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span class="caption grey--text pr-3">停车场区</span>
                      <span class="body-1">{{p.parkingLot.name}}</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <div>
                      <span class="caption grey--text pr-3">可预约次数</span>
                      <span class="body-1">{{p.times}}</span>
                    </div>
                  </v-list-tile-action>
                  <v-list-tile-action v-if="!readonly && enableReservation">
                    <v-menu left>
                      <v-btn slot="activator" icon small>
                        <v-icon small>$vuetify.icons.more</v-icon>
                      </v-btn>
                      <v-list dense>
                        <v-list-tile
                          @click="configDialog={activate: true,  status: 'edit',item: dealConfigPark(p), params: {type: 'group'}}"
                        >
                          <v-list-tile-title class="pr-1">
                            <v-flex layout align-center>
                              <span>修改配置</span>
                            </v-flex>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile
                          @click="deleteDialog = {activate: true, item: p, type: 'group'}"
                        >
                          <v-list-tile-title class="pr-1">
                            <v-flex layout align-center>
                              <span>删除配置</span>
                            </v-flex>
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile v-if="groupMaxReservationPerDay.length === 0">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <div class="text-xs-center grey--text">没有配置</div>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-flex v-if="!readonly && enableReservation">
                <v-btn
                  @click="configDialog={activate: true,  status: 'new', params: {type: 'group'}}"
                  class="px-0"
                  small
                  flat
                  color="primary"
                >添加配置
                </v-btn>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout column v-if="orderType==='order_object'">
              <div
                class="subheading grey--text pl-1"
              >个人单日可约次数上限
              </div>
              <v-list dense>
                <v-list-tile :key="i" v-for="(p,i) in personMaxReservationPerDay">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span class="caption grey--text pr-3">停车场区</span>
                      <span class="body-1">{{p.parkingLot.name}}</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <div>
                      <span class="caption grey--text pr-3">可预约次数</span>
                      <span class="body-1">{{p.times}}</span>
                    </div>
                  </v-list-tile-action>
                  <v-list-tile-action v-if="!readonly && enableReservation">
                    <v-btn icon small>
                      <v-menu left>
                        <v-btn slot="activator" icon small>
                          <v-icon small>$vuetify.icons.more</v-icon>
                        </v-btn>
                        <v-list dense>
                          <v-list-tile
                            @click="configDialog={activate: true,  status: 'edit',item: dealConfigPark(p), params: {type: 'person'}}"
                          >
                            <v-list-tile-title class="pr-1">
                              <v-flex layout align-center>
                                <span>修改配置</span>
                              </v-flex>
                            </v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile
                            @click="deleteDialog = {activate: true, item: p, type: 'person'}"
                          >
                            <v-list-tile-title class="pr-1">
                              <v-flex layout align-center>
                                <span>删除配置</span>
                              </v-flex>
                            </v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile v-if="personMaxReservationPerDay.length === 0">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <div class="text-xs-center grey--text">没有配置</div>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-flex v-if="!readonly && enableReservation">
                <v-btn
                  @click="configDialog={activate: true,  status: 'new', params: {type: 'person'}}"
                  class="px-0"
                  small
                  flat
                  color="primary"
                >添加配置
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-subheader>绑定模板</v-subheader>
            </v-layout>
            <v-form ref="form3">
              <v-layout :key="key" v-for="(t,key) in bindTemplates">
                <v-flex>
                  <v-text-field
                    :clearable="enableReservation && !readonly"
                    @click="templateDialog={activate: true, item: t.value.id, type: t.templateType, for: key}"
                    :label="t.label"
                    v-model="t.value.name"
                    readonly
                    :disabled="!enableReservation || readonly"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
          <v-layout justify-center>
            <v-btn color="grey" @click="cancelConfig" v-if="enableReservation" class="white--text">取消</v-btn>
            <v-btn class="primary" @click="submitConfig" v-if="enableReservation">確定</v-btn>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="templateDialog.activate" persistent max-width="500px">
      <l-select-template-dialog
        v-if="templateDialog.activate"
        :raw-item="templateDialog.item"
        :type="templateDialog.type"
        @cancel="templateDialog.activate = false"
        @save="bindTemplate($event, templateDialog.type, templateDialog.for)"
      ></l-select-template-dialog>
    </v-dialog>
    <l-confirm-delete-dialog
      item-text="配置"
      :item="deleteDialog.item"
      v-model="deleteDialog.activate"
      @delete="deleteConfig(deleteDialog.item, deleteDialog.type)"
      item-name="parkingLot.name"
    ></l-confirm-delete-dialog>
    <v-dialog v-model="configDialog.activate" max-width="500px" scrollable persistent>
      <parking-lot-config-content
        v-if="configDialog.activate"
        :raw-item="configDialog.item"
        :status="configDialog.status"
        :params="configDialog.params"
        @confirm="setConfig($event, configDialog.params.type)"
        @cancel="configDialog.activate = false"
      ></parking-lot-config-content>
    </v-dialog>
    <v-dialog v-model="controllerDialog.activate" max-width="600px" scrollable persistent>
      <pre-controllers-config
        v-if="controllerDialog.activate"
        :status="controllerDialog.status"
        :raw-item="controllerDialog.item"
        :raw-name="controllerDialog.name"
        @confirm="setControllerConfig($event)"
        @cancel="controllerDialog.activate = false"
      ></pre-controllers-config>
    </v-dialog>
  </l-layout>
</template>
<script>
import lSelectController from '../../../../components/LSelectController'
import parkingLotConfigContent from './parkingLotConfigContent'
import lConfirmDeleteDialog from '../../../../components/LConfirmDeleteDialog'
import lSelectTemplateDialog from '../../../../components/LSelectTemplateDialog'
import preControllersConfig from './preControllersConfig'
import debounce from 'lodash/debounce'
export default {
  name: 'PersonNewPersonalConfig',
  components: {
    lSelectController,
    parkingLotConfigContent,
    lConfirmDeleteDialog,
    lSelectTemplateDialog,
    preControllersConfig
  },
  props: {
    orderTypeProp: {type: String, default: 'letterReservation'},
    statusProp: {type: String, default: 'edit'},
    ownerTypeProp: {type: String, default: 'common'},
    ownerIdProp: {type: String, default: ''}
  },
  data () {
    return {
      orderType: '',
      ownerType: '',
      status: '',
      enableReservation: false,
      readonly: false,
      specificParkingLot: [],
      preControllers: [],
      groupMaxReservationPerDay: [],
      personMaxReservationPerDay: [],
      ownerId: '',
      search: '',
      searchSelects: [],
      memberLoading: false,
      isEnabled: false,
      configs: {
        // personMaxAllowed: {label: '个人每天最多可预约车辆数', value: 0, type: 'input', inputType: 'number', suffix: '辆'},
        // groupMaxAllowed: {label: '单位每天最多可预约车辆数', value: 0, type: 'input', inputType: 'number', suffix: '辆'},
        infoConfig: {label: '访客信息', type: 'header'},
        isVnNeeded: {label: '是否登记来访人员姓名', value: false, type: 'switch'},
        isVoNeeded: {label: '是否登记来访人员单位', value: false, type: 'switch'},
        reservationTime: {label: '预约时间', type: 'header'},
        maxAEn: {label: '允许提前进场时间上限', value: 0, type: 'input', inputType: 'number', suffix: '分'},
        maxDEx: {label: '允许延期出场时间上限', value: 0, type: 'input', inputType: 'number', suffix: '分'},
        maxDurDays: {label: '允许预约持续时间上限', value: 0, type: 'input', inputType: 'number', suffix: '天'},
        maxAdvDays: {label: '允许提前预约天数上限', value: 0, type: 'input', inputType: 'number', suffix: '天'},
        reservationInfo: {label: '预约提醒', type: 'header'},
        msgSuccess: {
          label: '预约申请成功信息提示',
          value: '0',
          type: 'select',
          items: [
            {text: '不发送', value: '-1'},
            {text: '仅访客', value: '0'},
            {text: '仅受访人', value: '1'},
            {text: '访客和受访人', value: '2'},
          ]
        }, // -1 nether, 0 visitor, 1 beVisited(host), 2 both
        msgDExWarning: {
          label: '车辆延迟出场信息警示',
          value: '0',
          type: 'select',
          items: [
            {text: '不发送', value: '-1'},
            {text: '仅访客', value: '0'},
            {text: '仅受访人', value: '1'},
            {text: '访客和受访人', value: '2'},
          ]
        }, // -1 nether, 0 visitor, 1 beVisited(host), 2 both
        msgInOut: {label: '车辆入场出场信息提示', value: false, type: 'switch'},
        msgDExAlarm: {label: '车辆延迟出场信息告警', value: false, type: 'switch'},
      },
      bindTemplates: {
        'apptMsgSuccToVIM': {label: '预约申请成功-来访人-短信', value: {id: '', name: ''}, templateType: 'sms'},
        'apptMsgSuccToHWC': {label: '预约申请成功-联系人-微信', value: {id: '', name: ''}, templateType: 'wechat'},
        'apptMsgVeInToHWC': {label: '预约车辆入场-联系人-微信', value: {id: '', name: ''}, templateType: 'wechat'},
        'apptMsgVeOtToHWC': {label: '预约车辆出场-联系人-微信', value: {id: '', name: ''}, templateType: 'wechat'},
        'apptMsgVeDoToHWC': {label: '延迟出场警示-来访人-短信', value: {id: '', name: ''}, templateType: 'sms'},
        'apptMsgVeDoToVIM': {label: '延迟出场警示-联系人-微信', value: {id: '', name: ''}, templateType: 'wechat'},
        'apptMsgVeDoToAWC': {label: '延迟出场警示-管理员-微信', value: {id: '', name: ''}, templateType: 'wechat'}
      },
      controllerDialog: {
        activate: false,
        status: 'new',
        item: '',
        index: 0,
        name: ''
      },
      configDialog: {
        activate: false,
        item: {},
        params: {type: 'person'}
      },
      deleteDialog: {
        activate: false,
        item: {},
        type: 'group'
      },
      templateDialog: {
        activate: false,
        item: {},
        type: '__NONE__'
      },
    }
  },
  created () {
    this.dealRouterParam()
    this.dealViewStatus()
  },
  activated () {

  },
  computed: {
    parkingLotSelects () {
      let selects = []
      if (this.items instanceof Array) {
        selects = this.items
      }
      else if (this.itemsP instanceof Array) {
        selects = this.itemsP
      }
      else if (this.$store.state.parkingLot.parkingLotList instanceof Array) {
        selects = this.$store.state.parkingLot.parkingLotList.slice()
      }
      if (selects.length === 0) {
        selects.push({header: '没有可选停车场区'})
      }
      return selects
    },
    controllers () {
      let cs = []
      if (this.items instanceof Array) {
        cs = Array.prototype.concat.apply([], this.items.map(t => t.controllers))
      }
      else if (this.itemsC instanceof Array) {
        cs = this.itemsC
      }
      else if (this.$store.state.parkingLot.controllerList instanceof Array) {
        cs = this.$store.state.parkingLot.controllerList.slice()
      }
      return cs
    },
  },
  watch: {
  },
  methods: {
    dealConfigPark(item){
      let arr1 = item.parkingLot.name.split(',')
      let arr2 = item.parkingLot.id.split(',')
      let res = []
      for(let i=0;i<arr1.length;i++){
        res.push({id:arr2[i],name:arr1[i]})
      }
      item.parkingLots = res
      console.log(res)
      return item
    },
    editControllerConfig (data, index) {
      var item2 = []
      for (let i = 0; i < data.item.length; i++) {
        var obj = {
          name: data.item[i].name,
          id: data.item[i].id,
          controllers: data.item[i].controllers
        }
        item2.push(obj)
      }
      // console.log(item2)
      this.controllerDialog.activate = true
      this.controllerDialog.status = 'edit'
      this.controllerDialog.item = item2
      this.controllerDialog.index = index
      this.controllerDialog.name = data.name
    },
    dealRouterParam () {
      if (this.$route.query.orderType !== undefined) {
        this.orderType = this.$route.query.orderType
      }
      else {
        this.orderType = this.orderTypeProp
      }
      if (this.$route.query.status !== undefined) {
        this.status = this.$route.query.status
      }
      else {
        this.status = this.statusProp
      }
      if (this.$route.query.ownerType !== undefined) {
        this.ownerType = this.$route.query.ownerType
      }
      else {
        this.ownerType = this.ownerTypeProp
      }
      if (this.$route.query.ownerId !== undefined) {
        this.ownerId = this.$route.query.ownerId
      }
      else {
        this.ownerId = this.ownerIdProp
      }
    },
    dealViewStatus () {
      if (this.status === 'readonly') {
        this.readonly = true
        this.enableReservation = false
        this.getConfig()
      }
      else if (this.status === 'new') {
        this.readonly = false
        this.enableReservation = true
        if(this.$route.query.userId!==undefined){
          this.getConfigUser(this.$route.query.userId)
        }
      }
    },
    setEnableReservation () {
      this.enableReservation = true
      this.readonly = false
    },
    async getConfig () {
      if (this.ownerType === 'common') {
        let param = 'vehicle_appt_global_config:' + this.orderType
        let res = await this.$store.dispatch('personReservationConfig/getCommonConfig', param)
        if (res.data.status === 1) {
          this.dealConfigData(res.data.data)
        }
        else {
          this.$L.alert('error', {message: '查询配置信息失败，原因：' + res.data.msg})
        }
      }
      else {
        let res = await this.$store.dispatch('personReservationConfig/getConfig', {orderType: this.orderType, ownerId: this.ownerId, ownerType: this.ownerType})
        if (res.data.status === 1) {
          console.log(res)
          let config = eval('(' + res.data.data.content[0].vehicle.ruleJson + ')')
          this.dealConfigData(config)
          if (this.ownerType === 'group') {
            this.getConfigGroup(res.data.data.content[0].group.id)
          }
          else {
            this.getConfigUser(res.data.data.content[0].user.id)
          }
        }
        else {
          this.$L.alert('error', {message: '查询配置信息失败，原因：' + res.data.msg})
        }
      }
    },
    async getConfigGroup (id) {
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'id': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': id,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('personReservationConfig/getGroups', {param: param, pagination: pagination})
      if (res.data.status === 1) {
        this.ownerId = res.data.data.content[0]
        this.searchSelects = []
        this.searchSelects.push(res.data.data.content[0])
        console.log(this.ownerId)
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    async getConfigUser (id) {
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'id': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': id,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('personReservationConfig/getUsers', {param: param, pagination: pagination})
      if (res.data.status === 1) {
        this.ownerId = res.data.data.content[0]
        this.searchSelects = []
        this.searchSelects.push(res.data.data.content[0])
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    dealConfigData (data) {
      console.log(data)
      this.isEnabled = data.isEnabled
      this.configs.isVnNeeded.value = data.isVnNeeded
      this.configs.isVoNeeded.value = data.isVoNeeded
      this.configs.maxAdvDays.value = data.maxAdvDays
      this.configs.maxAEn.value = data.maxAEn
      this.configs.maxDEx.value = data.maxDEx
      this.configs.maxDurDays.value = data.maxDurDays
      this.configs.msgSuccess.value = data.msgSuccess
      this.configs.msgDExAlarm.value = data.msgDExAlarm
      this.configs.msgDExWarning.value = data.msgDExWarning
      this.configs.msgInOut.value = data.msgInOut
      this.personMaxReservationPerDay = []
      this.groupMaxReservationPerDay = []
      for (let i = 0; i < data.maxAppts1p1d.length; i++) {
        let arr = data.maxAppts1p1d[i].parklotId.split(',')
        let obj = {
          times: data.maxAppts1p1d[i].times,
          parkingLot: {
            name:"",
            id: ""
          }
        }
        for(let j=0;j<arr.length;j++){
          for(let k=0;k<this.parkingLotSelects.length;k++){
            if(arr[j]===this.parkingLotSelects[k].id){
              if(j===arr.length-1){
                obj.parkingLot.name+=this.parkingLotSelects[k].name
                obj.parkingLot.id+=this.parkingLotSelects[k].id
              }else{
                obj.parkingLot.name+=this.parkingLotSelects[k].name+','
                obj.parkingLot.id+=this.parkingLotSelects[k].id+','
              }
            }
          }
        }
        this.personMaxReservationPerDay.push(obj)
      }
      for (let i = 0; i < data.maxAppts1o1d.length; i++) {
        let arr = data.maxAppts1o1d[i].parklotId.split(',')
        let obj1 = {
          times: data.maxAppts1o1d[i].times,
          parkingLot: {
            name:"",
            id: ""
          }
        }
        for(let j=0;j<arr.length;j++){
          for(let k=0;k<this.parkingLotSelects.length;k++){
            if(arr[j]===this.parkingLotSelects[k].id){
              if(j===arr.length-1){
                obj1.parkingLot.name+=this.parkingLotSelects[k].name
                obj1.parkingLot.id+=this.parkingLotSelects[k].id
              }else{
                obj1.parkingLot.name+=this.parkingLotSelects[k].name+','
                obj1.parkingLot.id+=this.parkingLotSelects[k].id+','
              }
            }
          }
        }
        this.groupMaxReservationPerDay.push(obj1)
      }
      console.log(data)
      this.dealBindTemplates(data.msgTmpl)
      this.dealDisabledControllers(data.isApptEnabled)
      this.dealPreControllers(data.presetCtrls)
    },
    dealBindTemplates (data) {
      for (let n in data) {
        this.bindTemplates[n].value.id = data[n].key
        this.bindTemplates[n].value.name = data[n].name
      }
    },
    dealDisabledControllers (data) {
      this.specificParkingLot = []
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < this.parkingLotSelects.length; j++) {
          if (data[i].parklotId === this.parkingLotSelects[j].id) {
            var obj = {
              name: this.parkingLotSelects[j].name,
              id: this.parkingLotSelects[j].id,
              controllers: []
            }
            for (let k = 0; k < data[i].isCtrlEnabled.length; k++) {
              for (let n = 0; n < this.controllers.length; n++) {
                if (data[i].isCtrlEnabled[k].controllerId === this.controllers[n].id) {
                  obj.controllers.push(this.controllers[n])
                }
              }
            }
            this.specificParkingLot.push(obj)
          }
        }
      }
    },
    dealPreControllers (data) {
      for (let k = 0; k < data.length; k++) {
        var name = data[k].name
        var controllers = []
        var items = []
        for (let i = 0; i < data[k].controllerIds.length; i++) {
          for (let j = 0; j < this.controllers.length; j++) {
            if (this.controllers[j].id === data[k].controllerIds[i]) {
              controllers.push(this.controllers[j])
            }
          }
        }
        for (let i = 0; i < this.parkingLotSelects.length; i++) {
          var item = {
            name: this.parkingLotSelects[i].name,
            id: this.parkingLotSelects[i].id,
            controllers: []
          }
          for (let j = 0; j < controllers.length; j++) {
            if (controllers[j].parkingLot.id === this.parkingLotSelects[i].id) {
              item.controllers.push(controllers[j])
            }
          }
          if (item.controllers.length !== 0) {
            items.push(item)
          }
        }
        var config = {
          name: name,
          controllers: controllers,
          item: items
        }
        this.preControllers.push(config)
      }
    },
    checkConfigValid () {
      return this.$refs.form1.validate() && this.$refs.form2.validate() && this.$refs.form3.validate()
    },
    cancelConfig () {
      this.enableReservation = false
    },
    async submitConfig () {
      console.log(this.bindTemplates)
      let maxAppts1o1d = []
      let maxAppts1p1d = []
      let presetCtrls = []
      let isApptEnabled = []
      for (let i = 0; i < this.groupMaxReservationPerDay.length; i++) {
        var obj = {
          'parklotId': this.groupMaxReservationPerDay[i].parkingLot.id,
          'times': this.groupMaxReservationPerDay[i].times
        }
        maxAppts1o1d.push(obj)
      }
      for (let i = 0; i < this.personMaxReservationPerDay.length; i++) {
        var obj = {
          'parklotId': this.personMaxReservationPerDay[i].parkingLot.id,
          'times': this.personMaxReservationPerDay[i].times
        }
        maxAppts1p1d.push(obj)
      }
      for (let i = 0; i < this.preControllers.length; i++) {
        var obj = {
          'name': this.preControllers[i].name,
          'controllerIds': []
        }
        for (let j = 0; j < this.preControllers[i].controllers.length; j++) {
          obj['controllerIds'].push(this.preControllers[i].controllers[j].id)
        }
        presetCtrls.push(obj)
      }
      // console.log(this.specificParkingLot)
      for (let i = 0; i < this.specificParkingLot.length; i++) {
        var obj = {
          parklotId: this.specificParkingLot[i].id,
          isEnabled: false,
          isCtrlEnabled: []
        }
        for (let j = 0; j < this.specificParkingLot[i].controllers.length; j++) {
          let item = {
            controllerId: this.specificParkingLot[i].controllers[j].id,
            isEnabled: false
          }
          obj.isCtrlEnabled.push(item)
        }
        isApptEnabled.push(obj)
      }
      // console.log(isApptEnabled)
      let configJson = {
        'isApptEnabled': isApptEnabled,
        'isEnabled': this.isEnabled,
        'isVnNeeded': this.configs.isVnNeeded.value,
        'isVoNeeded': this.configs.isVoNeeded.value,
        'maxAEn': this.configs.maxAEn.value,
        'maxAdvDays': this.configs.maxAdvDays.value,
        'presetCtrls': presetCtrls,
        'maxAppts1o1d': maxAppts1o1d,
        'maxAppts1p1d': maxAppts1p1d,
        'maxDEx': this.configs.maxDEx.value,
        'maxDurDays': this.configs.maxDurDays.value,
        'msgDExAlarm': this.configs.msgDExAlarm.value,
        'msgDExWarning': this.configs.msgDExWarning.value,
        'msgInOut': this.configs.msgInOut.value,
        'msgSuccess': this.configs.msgSuccess.value,
        'msgTmpl': {
          'apptMsgSuccToHWC': {
            'key': this.bindTemplates.apptMsgSuccToHWC.value.id,
            'name': this.bindTemplates.apptMsgSuccToHWC.value.name
          },
          'apptMsgSuccToVIM': {
            'key': this.bindTemplates.apptMsgSuccToVIM.value.id,
            'name': this.bindTemplates.apptMsgSuccToVIM.value.name
          },
          'apptMsgVeDoToAWC': {
            'key': this.bindTemplates.apptMsgVeDoToAWC.value.id,
            'name': this.bindTemplates.apptMsgVeDoToAWC.value.name
          },
          'apptMsgVeDoToHWC': {
            'key': this.bindTemplates.apptMsgVeDoToHWC.value.id,
            'name': this.bindTemplates.apptMsgVeDoToHWC.value.name
          },
          'apptMsgVeDoToVIM': {
            'key': this.bindTemplates.apptMsgVeDoToVIM.value.id,
            'name': this.bindTemplates.apptMsgVeDoToVIM.value.name
          },
          'apptMsgVeInToHWC': {
            'key': this.bindTemplates.apptMsgVeInToHWC.value.id,
            'name': this.bindTemplates.apptMsgVeInToHWC.value.name
          },
          'apptMsgVeOtToHWC': {
            'key': this.bindTemplates.apptMsgVeOtToHWC.value.id,
            'name': this.bindTemplates.apptMsgVeOtToHWC.value.name
          }
        }
      }
      if (this.ownerType === 'common') {
        let res = await this.$store.dispatch('personReservationConfig/submitConfig', {config: configJson, type: this.orderType})
        if (res.data.status === 1) {
          this.enableReservation = false
          if (this.status === 'new') {
            this.$L.alert('success', {message: '创建成功'})
          }
          else {
            this.$L.alert('success', {message: '修改成功'})
          }
        }
        else {
          this.$L.alert('error', {message: '提交失败，原因：' + res.data.msg})
        }
      }
      else {
        let orderConfig = {
          'ownerId': (this.ownerId.id === undefined) ? this.ownerId : this.ownerId.id,
          'ownerType': this.ownerType,
          'orderType': this.orderType
        }
        let param = {
          'orderConfig': orderConfig,
          'config': configJson
        }
        let res = await this.$store.dispatch('personReservationConfig/putConfig', param)
        if (res.data.status === 1) {
          this.enableReservation = false
          if (this.status === 'new') {
            this.$L.alert('success', {message: '创建成功'})
          }
          else {
            this.$L.alert('success', {message: '修改成功'})
          }
        }
        else {
          this.$L.alert('error', {message: res.data.msg})
        }
      }
    },
    bindTemplate (t, type, key) {
      // console.log('bind template', t, type, key)
      this.bindTemplates[key].value = {id: t.id, name: t.name}
      this.templateDialog.activate = false
    },
    deleteConfig (v, type) {
      if (!v) {
        this.deleteDialog.activate = false
        return
      }
      if (type === 'group') {
        let i = this.groupMaxReservationPerDay.indexOf(v)
        if (i >= 0) {
          this.groupMaxReservationPerDay.splice(i, 1)
        }
      }
      if (type === 'person') {
        let i = this.personMaxReservationPerDay.indexOf(v)
        if (i >= 0) {
          this.personMaxReservationPerDay.splice(i, 1)
        }
      }
      this.deleteDialog.activate = false
    },
    setConfig (c, type) {
      // console.log(c)
      let {newItem, oldItem, status} = c
      if (type === 'group') {
        if (status === 'new') {
          for(let i=0;i<this.groupMaxReservationPerDay.length;i++){
            if(this.groupMaxReservationPerDay[i].parkingLot.id===c.newItem.parkingLot.id){
              return
            }
          }
          this.groupMaxReservationPerDay.push(c.newItem)
        }
        else {
          let i = this.groupMaxReservationPerDay.indexOf(oldItem)
          // console.log('index', i, this.groupMaxReservationPerDay, oldItem)
          if (i >= 0) {
            this.groupMaxReservationPerDay.splice(i, 1, newItem)
          }
        }
      }
      if (type === 'person') {
        if (status === 'new') {
          for(let i=0;i<this.personMaxReservationPerDay.length;i++){
            if(this.personMaxReservationPerDay[i].parkingLot.id === c.newItem.parkingLot.id){
              this.$L.alert("error",{message:"已有相同园区配置"})
              return
            }
          }
          this.personMaxReservationPerDay.push(c.newItem)
        }
        else {
          let i = this.personMaxReservationPerDay.indexOf(oldItem)
          if (i >= 0) {
            this.personMaxReservationPerDay.splice(i, 1, newItem)
          }
        }
      }
      this.configDialog.activate = false
    },
    setControllerConfig (c) {
      let {newItem, oldItem, status, name} = c
      if (status === 'new') {
        let config = {
          name: name,
          controllers: [],
          item: newItem
        }
        for (let i = 0; i < newItem.length; i++) {
          for (let j = 0; j < newItem[i].controllers.length; j++) {
            config.controllers.push(newItem[i].controllers[j])
          }
        }
        this.preControllers.push(config)
      }
      else {
        let config = this.preControllers[this.controllerDialog.index]
        config.item = newItem
        config.name = name
        config.controllers = []
        for (let i = 0; i < newItem.length; i++) {
          for (let j = 0; j < newItem[i].controllers.length; j++) {
            config.controllers.push(newItem[i].controllers[j])
          }
        }
        this.preControllers.splice(this.controllerDialog.index, 1, config)
      }
      console.log(this.preControllers)
      this.controllerDialog.activate = false
    },
    async deleteControllerConfig (index) {
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要删除该配置？'})
      if (res) {
        this.preControllers.splice(index, 1)
      }
      close()
    },
    getSelection: debounce(async function (param) {
      let search = (param === undefined) ? '' : param.target.value
      let pagination = {page: 0, rowsPerPage: this.ownerType === 'group' ? 20 : 100}
      if (this.ownerType === 'group') {
        let param = {
          'searchParam': {
            'name': {
              'index': '1',
              'order': 'ASC',
              'operators': [
                {
                  'keyword': search,
                  'operator': 'LIKE',
                  'matchType': 'BOTH'
                }
              ]
            }
          }
        }
        let res = await this.$store.dispatch('personReservationConfig/getGroups', {param: param, pagination: pagination})
        if (res.data.status === 1) {
          this.searchSelects = res.data.data.content
        }
        else {
          this.searchSelects = []
        }
      }
      else if (this.ownerType === 'object') {
        let param = {
          'searchParam': {
            'name': {
              'index': '1',
              'order': 'ASC',
              'operators': [
                {
                  'keyword': search,
                  'operator': 'LIKE',
                  'matchType': 'BOTH'
                }
              ]
            }
          }
        }
        let res = await this.$store.dispatch('personReservationConfig/getUsers', {param: param, pagination: pagination})
        if (res.data.status === 1) {
          this.searchSelects = res.data.data.content
        }
        else {
          this.searchSelects = []
        }
      }
    }, 600),
  }
}
</script>
